import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  class: "official"
};
var _hoisted_2 = {
  class: "contact-content"
};
var _hoisted_3 = {
  class: "qr-item"
};
var _hoisted_4 = {
  class: "qr-code-wrapper"
};
var _hoisted_5 = ["src"];
var _hoisted_6 = {
  class: "actions"
};
var _hoisted_7 = ["href"];
var _hoisted_8 = ["src"];
var _hoisted_9 = ["href"];
var _hoisted_10 = ["src"];
var _hoisted_11 = {
  class: "footer-section"
};
var _hoisted_12 = {
  class: "footer-content"
};
var _hoisted_13 = {
  class: "footer-left"
};
var _hoisted_14 = ["src"];
var _hoisted_15 = {
  class: "footer-right"
};
var _hoisted_16 = {
  class: "footer-links"
};
var _hoisted_17 = ["src"];
var _hoisted_18 = ["src"];
var _hoisted_19 = {
  key: 0,
  class: "tips-container"
};
var _hoisted_20 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Privacy = _resolveComponent("Privacy");
  var _component_van_popup = _resolveComponent("van-popup");
  var _component_ServiceContract = _resolveComponent("ServiceContract");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[15] || (_cache[15] = _createElementVNode("div", {
    class: "header-section"
  }, [_createElementVNode("video", {
    src: "https://tanshiqipao-test.oss-cn-hangzhou.aliyuncs.com/front/media/official.mp4",
    autoplay: "",
    muted: "",
    loop: "",
    playsinline: "",
    "webkit-playsinline": "",
    "x5-playsinline": "",
    controls: "",
    class: "official-video"
  })], -1)), _createElementVNode("div", {
    class: "contact-section",
    style: _normalizeStyle({
      backgroundImage: "url(".concat($data.contactBg, ")")
    })
  }, [_cache[9] || (_cache[9] = _createElementVNode("div", {
    class: "contact-title"
  }, "联系我们", -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
    src: $data.groupScan,
    alt: "创作者交流群二维码",
    class: "qr-code"
  }, null, 8, _hoisted_5)]), _cache[6] || (_cache[6] = _createElementVNode("p", {
    class: "qr-desc"
  }, [_createTextVNode("扫描上方二维码加入起创作者交流群"), _createElementVNode("br"), _createTextVNode("和大家一起交流创作心得分享创作成果")], -1))]), _createElementVNode("div", _hoisted_6, [_createElementVNode("a", {
    class: "btn ios",
    href: $data.iosUrl,
    target: "_blank",
    rel: "noopener",
    onClick: _cache[0] || (_cache[0] = function () {
      return $options.onIosClick && $options.onIosClick.apply($options, arguments);
    })
  }, [_createElementVNode("img", {
    src: $data.ioslogo,
    alt: "iOS",
    class: "icon"
  }, null, 8, _hoisted_8), _cache[7] || (_cache[7] = _createTextVNode(" iOS 下载 ", -1))], 8, _hoisted_7), _createElementVNode("a", {
    class: "btn android",
    href: $data.androidUrl,
    target: "_blank",
    rel: "noopener",
    onClick: _cache[1] || (_cache[1] = function () {
      return $options.onAndroidClick && $options.onAndroidClick.apply($options, arguments);
    })
  }, [_createElementVNode("img", {
    src: $data.androidlogo,
    alt: "Android",
    class: "icon"
  }, null, 8, _hoisted_10), _cache[8] || (_cache[8] = _createTextVNode(" Android 下载 ", -1))], 8, _hoisted_9)])])], 4), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("img", {
    src: $data.logo,
    alt: "起泡AI",
    class: "footer-logo"
  }, null, 8, _hoisted_14), _cache[10] || (_cache[10] = _createElementVNode("p", {
    class: "footer-slogan"
  }, "让每一个有故事的人,都能成为创作者", -1)), _cache[11] || (_cache[11] = _createElementVNode("p", {
    class: "footer-copyright"
  }, "©2024起泡AI-保留所有权利", -1))]), _createElementVNode("div", _hoisted_15, [_cache[14] || (_cache[14] = _createElementVNode("div", {
    class: "footer-email"
  }, [_createElementVNode("div", {
    class: "email-title"
  }, "联系邮箱"), _createElementVNode("div", {
    class: "email-address"
  }, "yingsai2025@163.com")], -1)), _createElementVNode("div", _hoisted_16, [_createElementVNode("a", {
    href: "javascript:void(0)",
    class: "footer-link",
    onClick: _cache[2] || (_cache[2] = function () {
      return $options.goPrivary && $options.goPrivary.apply($options, arguments);
    })
  }, [_cache[12] || (_cache[12] = _createTextVNode(" 隐私政策 ", -1)), _createElementVNode("img", {
    src: $data.arrowUpRight,
    alt: "外部链接",
    class: "link-icon"
  }, null, 8, _hoisted_17)]), _createElementVNode("a", {
    href: "javascript:void(0)",
    class: "footer-link",
    onClick: _cache[3] || (_cache[3] = function ($event) {
      return $data.showTermsModal = true;
    })
  }, [_cache[13] || (_cache[13] = _createTextVNode(" 服务条款 ", -1)), _createElementVNode("img", {
    src: $data.arrowUpRight,
    alt: "外部链接",
    class: "link-icon"
  }, null, 8, _hoisted_18)])])])])]), _createVNode(_component_van_popup, {
    show: $data.showPrivacyModal,
    "onUpdate:show": _cache[4] || (_cache[4] = function ($event) {
      return $data.showPrivacyModal = $event;
    }),
    position: "center",
    style: {
      width: '90%',
      maxWidth: '850px',
      height: '80vh',
      maxHeight: '700px'
    },
    round: "",
    closeable: "",
    "close-icon-position": "top-right",
    class: "policy-popup"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_Privacy)];
    }),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $data.showTermsModal,
    "onUpdate:show": _cache[5] || (_cache[5] = function ($event) {
      return $data.showTermsModal = $event;
    }),
    position: "center",
    style: {
      width: '90%',
      maxWidth: '850px',
      height: '80vh',
      maxHeight: '700px'
    },
    round: "",
    closeable: "",
    "close-icon-position": "top-right",
    class: "policy-popup"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_ServiceContract)];
    }),
    _: 1
  }, 8, ["show"]), $data.showTips ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("img", {
    src: $data.downtips,
    alt: "downtips"
  }, null, 8, _hoisted_20)])) : _createCommentVNode("", true)]);
}